import React from "react";
import styles from "../PerfilMain.module.scss";
import gestionStyles from "./ProfileGestion.module.scss";
import MisProyectos from "../MisProyectos/MisProyectos";
import MisAccesos from "../MisAccesos/MisAccesos";
import MisCotizacionesDeMateriales from "../MisCotizacionesDeMateriales/MisCotizacionesDeMateriales.js";
import MisDocumentacionesObra from "../MisDocumentacionesObra/MisDocumentacionesObra.tsx";
import MisComercioGestion from "../MisComercioGestion/MisComercioGestion.tsx";
import {
  GESTION_SECTION_QUERY_TO_LABEL,
  type ProfileGestionSection,
} from "../../../../utils/navigationHelpers.ts";

interface ProfileGestionProps {
  section: ProfileGestionSection;
  onSectionChange: (section: ProfileGestionSection) => void;
  perfilAjeno?: string | number;
  userData: any;
  profileVisualizerData: any;
  setInfoReady: (ready: boolean) => void;
}

const SECTIONS: ProfileGestionSection[] = [
  "cotizaciones",
  "comercio",
  "accesos",
  "documentaciones",
  "proyectos",
];

const ProfileGestion: React.FC<ProfileGestionProps> = ({
  section,
  onSectionChange,
  perfilAjeno,
  userData,
  profileVisualizerData,
  setInfoReady,
}) => {
  return (
    <div className={styles.sectionContent}>
      <div
        className={gestionStyles.subTabs}
        role="tablist"
        aria-label="Secciones de gestión"
      >
        {SECTIONS.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={section === key}
            className={`${gestionStyles.subTab} ${
              section === key ? gestionStyles.subTabActive : ""
            }`}
            onClick={() => onSectionChange(key)}
          >
            {GESTION_SECTION_QUERY_TO_LABEL[key]}
          </button>
        ))}
      </div>
      {section === "proyectos" && (
        <MisProyectos
          fromPage
          myPerson
          perfilAjeno={perfilAjeno}
          userData={userData}
          setInfoReady={setInfoReady}
          currentTab="Gestión"
          gestionNavSection="proyectos"
        />
      )}
      {section === "cotizaciones" && (
        <MisCotizacionesDeMateriales
          myPerson
          setInfoReady={setInfoReady}
          profileVisualizerData={profileVisualizerData}
          profileReturnTab="Gestión"
          profileReturnGestionSection="cotizaciones"
        />
      )}
      {section === "accesos" && (
        <MisAccesos myPerson setInfoReady={setInfoReady} />
      )}
      {section === "documentaciones" && (
        <MisDocumentacionesObra
          myPerson
          userData={userData}
          profileVisualizerData={profileVisualizerData}
          perfilAjeno={perfilAjeno}
          setInfoReady={setInfoReady}
          currentTab="Gestión"
          documentationSurface="full"
          gestionNavSection="documentaciones"
        />
      )}
      {section === "comercio" && (
        <MisComercioGestion userData={userData} setInfoReady={setInfoReady} />
      )}
    </div>
  );
};

export default ProfileGestion;
